import { useSpreedlyPayments } from './spreedly-payments.hooks';
import { SpreedlyProvider } from './spreedly.context';

const SpreedlyPayments = ({ children }) => {
  const value = useSpreedlyPayments();
  return <SpreedlyProvider value={value}>{children}</SpreedlyProvider>;
};

export default SpreedlyPayments;
